import { render } from "./add.vue?vue&type=template&id=36c65d70&ts=true"
import script from "./add.vue?vue&type=script&lang=ts"
export * from "./add.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__